// INITIAL STATE
// ==========================================================================

export const initialState = {
  currentLayout: 'Main', // 'project' || 'sensitivity'

  // Project
  projectIds: [],
  projectsById: {},
  selectedProjectIds: [],
  selectedCasingIds: [],
  selectedCementIds: [],

  // Project General Input
  inputGeneralByProjectId: {},
  inputPressureByProjectId: {},
  inputCementProgramByProjectId: {},

  outputKeyInfoByProjectId: {},
  outputSummaryByProjectId: {},
  outputPumpByProjectId: {},

  // Settings
  settings: {}
};

export default initialState;
